export default function demoQuote({ stores }: CommandArgs) {
  const quoteStore: QuoteStore = stores['quote']

  async function echoQuote(): Promise<Quote | undefined> {
    return quoteStore.quote.value ?? undefined
  }

  return { applyRedemptionCode: echoQuote, removeRedemptionCode: echoQuote }
}
